import Button from "devextreme-react/button";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { useAuth } from "../../../../contexts/auth";
import { CompanyTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitCreditMemo } from "../api/submit-credit-memo";
import { POCreditMemoContext } from "../context/POCreditMemoContext";

export default function SubmitCreditMemoButton() {

	const { creditMemo } = useContext(POCreditMemoContext);

	const navigate = useNavigate();

	let [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	const { user } = useAuth();
	const urlFolder = user?.companyTypeId === CompanyTypes.MFR ? "manufacturer" :
		user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER ? "service-provider" : "distributor";

	const submitCreditMemo = useSubmitCreditMemo({
		creditMemo: {
			purchaseOrderID: creditMemo.details.purchaseOrderID,
			creditMemoNumber: creditMemo.details.creditMemoNumber!,
			balance: creditMemo.details.balance,
			poInvoiceID: creditMemo.details.poInvoiceID,
			shippingChargeAmount: creditMemo.details.shippingChargeAmount,
			shippingChargeDescription: creditMemo.details.shippingChargeDescription
		},
		products: creditMemo.details.products.map((x, index) => {
			return {
				poProductID: x.poProductID!,
				productID: x.productID,
				description: x.description,
				quantity: x.quantity,
				price: x.price,
				amount: -x.quantity * x.price
			}
		}),
		onSuccess: (creditMemoID: number) => {
			showSuccessMessage('Credit memo has been submitted');
			navigate(`/${urlFolder}/credit-memo/${creditMemo.details.purchaseOrderID}/${creditMemoID}` +
				(!!returnUrl ? '?returnUrl=' + returnUrl : ''));
		},
		onError: (error) => showErrorMessage(error)
	});

	return (
		<>
			<Button
				text="Submit Credit Memo"
				icon="Inscyth-Confirm"
				disabled={submitCreditMemo.isLoading}
				onClick={(e) => {
					let result = e.validationGroup.validate();
					if (result.isValid) {
						submitCreditMemo.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={submitCreditMemo.isLoading}></LoadPagePanel>
		</>
	)
}
